import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {CustomerService} from 'app/blocks/service/api/customer.service';
import {Resource} from 'app/constants/resource';

import {ENTITIES_SETUP_BASE_URL} from 'app/app.constants';
import {ICustomer} from 'app/blocks/model/customer.model';
import {EntityNavigator} from 'app/blocks/routing/navigator';
import {Customer} from 'app/blocks/model/customer.model';
import {EntityUrlProvider} from 'app/blocks/routing/entity-url-provider';
import {AbstractEntityResource} from 'app/blocks/resource/abstract-entity-resource';

@Injectable({
    providedIn: 'root'
})
export class CustomerResource extends AbstractEntityResource<ICustomer> {
    constructor(customerService: CustomerService, router: Router) {
        super(
            Resource.CUSTOMERS,
            customerService,
            new EntityNavigator(ENTITIES_SETUP_BASE_URL, Resource.CUSTOMERS, router),
            new EntityUrlProvider(ENTITIES_SETUP_BASE_URL, Resource.CUSTOMERS),
            (entity?) => new Customer(entity),
            (entity) => entity.name,
            'supervisor_account',
            'user'
        );
    }
}
